// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional


const firebaseConfig = {
  apiKey: "AIzaSyBQatr12zTXfiJjBzmgxvVSPw3c9ulFYqI",
  authDomain: "guardian-tech-4117c.firebaseapp.com",
  projectId: "guardian-tech-4117c",
  storageBucket: "guardian-tech-4117c.firebasestorage.app",
  messagingSenderId: "247247974509",
  appId: "1:247247974509:web:f5d4641a0f163cdf590f64",
  measurementId: "G-M07VKCWGWH"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export const auth = getAuth(app);
export const firebaseMessaging = messaging;
export default app;